import Lenis from "lenis";

export function createHorizontalScroll({ wrapper, content, options = {} }) {
  if (!wrapper || !content) {
    return null;
  }

  const lenis = new Lenis({
    autoRaf: false,
    wrapper,
    content,
    orientation: "horizontal",
    gestureOrientation: "both",
    lerp: 0.1,
    wheelMultiplier: 1,
    smoothWheel: true,
    touchMultiplier: 1.5,
    ...options,
  });

  return lenis;
}
